import { render } from "./ReservationLocation.vue?vue&type=template&id=51820a05"
import script from "./ReservationLocation.vue?vue&type=script&lang=js"
export * from "./ReservationLocation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\anygence\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__